<template>
    <span>{{ durationText() }}</span>
</template>

<script setup>

    const props = defineProps({
        duration: {
            type: Number,
            default: 0
        }
    })

    const durationText = () => {
    if (props.duration >= 60) {
        const hours = Math.floor(props.duration / 60);
        return `${hours} ساعة`;
    } else {
        const minutes = Math.round(props.duration);
        return `${minutes} دقيقة`;
    }
}
</script>